const DataImportLogs = () => import("Core/configuration/data_import_logs/views/DataImportLogs");
const DataImportLogsForm = () => import("Core/configuration/data_import_logs/views/DataImportLogsForm");

export default {
    children: [
        {
            path: "configuration/data_import_logs",
            name: "data_import_logs",
            component: DataImportLogs,
            meta: {
                requiresAuth: true,
                title: "lang.data_import_logs",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/data_import_log/:id?",
            name: "data_import_log",
            component: DataImportLogsForm,
            meta: {
                requiresAuth: true,
                title: "lang.data_import_logs",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
